import DesignFigure from 'common/components/DesignFigure';
import Heading from 'common/components/Heading';
import Paragraph from 'common/components/Paragraph';
import Icon from 'launch/components/Icon';
import Link from 'launch/components/Link';
import ContentSideFeature from 'projects/components/SmartShoot/ContentSideFeature';
import React from 'react';

export interface StepsContent {
    icon: string;
    heading: string;
    paragraph: string;
}

interface Props {
    rescheduleUrl: string;
    stepContent: StepsContent[];
    imageSource: string;
}
export default class BriefGetStartedContent extends React.Component<Props> {
    render() {
        const stepsPerRow = 3;

        return (
            <>
                <div className="section">
                    <div className="row">
                        <div className="column">{this.renderContentHeader()}</div>
                    </div>
                </div>
                <div className="section">
                    {this.stepsRows(stepsPerRow).map((row, rowIndex) => {
                        return (
                            <div key={rowIndex} className="row">
                                {row.map((content, colIndex) => {
                                    return this.renderStepsColumn(
                                        colIndex,
                                        content,
                                        colIndex + 1 + rowIndex * stepsPerRow
                                    );
                                })}
                                {rowIndex === 1 &&
                                    this.props.rescheduleUrl &&
                                    this.renderRescheduleContent()}
                            </div>
                        );
                    })}
                </div>
            </>
        );
    }

    renderStepsColumn(index: number, content: StepsContent, stepCount: number) {
        return (
            <div key={index} className="column large-4 normal-4 medium-12 small-12">
                <Heading size="h5" variations={['heading--quarter-margin']}>
                    <Icon icon={content.icon} offsetRight={true} />
                    {`${stepCount}.`} {content.heading}
                </Heading>
                <Paragraph color="soft">{content.paragraph}</Paragraph>
            </div>
        );
    }

    renderRescheduleContent() {
        return (
            <div className="column large-4 normal-4 medium-12 small-12">
                <div className="colored-tile colored-tile--grey">
                    <p className="paragraph paragraph--capped paragraph--no-margin">
                        Need to reschedule?
                    </p>
                    <p className="paragraph paragraph--capped paragraph--soft paragraph--no-margin">
                        Simply visit SmartShoot
                        <Link
                            noWrap={true}
                            href={this.props.rescheduleUrl}
                            target="_blank"
                            variations={['default', 'soft']}
                        >
                            {' to reschedule your shoot date and time'}
                        </Link>
                        . Please avoid changing your scheduled time 48 hours before the shoot.
                    </p>
                </div>
            </div>
        );
    }

    renderContentHeader() {
        return (
            <ContentSideFeature
                top={
                    <div style={{ color: '#e18776' }}>
                        <h2 className="heading heading--h1 heading--with-divider heading--chameleon heading--no-margin">
                            What’s next?
                        </h2>
                    </div>
                }
                side={
                    <DesignFigure
                        attribution="By Lucadia"
                        variations={['smartshoot-video-pig']}
                        imageSource={this.props.imageSource}
                    />
                }
                bottom={
                    <p className="paragraph paragraph--capped paragraph--no-margin paragraph--offset">
                        Check your email for your order confirmation. <br />
                        You can also go to the '
                        <Link noWrap={true} href="/work/in-progress" variations={['default']}>
                            {'Your work'}
                        </Link>
                        ' section of your profile to check your project status.
                    </p>
                }
            />
        );
    }

    stepsRows(stepsPerRow: number) {
        const rows = [];

        for (
            let index = 0;
            index < Math.ceil(this.props.stepContent.length / stepsPerRow);
            index++
        ) {
            const start = index * stepsPerRow;
            const end = start + stepsPerRow;

            rows.push(this.props.stepContent.slice(start, end));
        }

        return rows;
    }
}
